import { Component, OnInit, OnDestroy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-session-timeout-modal',
	templateUrl: './session-timeout-modal.component.html',
	styleUrl: './session-timeout-modal.component.scss'
})
export class SessionTimeoutModalComponent implements OnInit, OnDestroy {
	remainingSeconds: number = 300; // 5 minutes default
	private destroy$ = new Subject<void>();

	constructor(
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {}

	ngOnInit(): void {
		const countdown$ = this.config.data?.countdown$ as BehaviorSubject<number>;
		if (countdown$) {
			countdown$.pipe(takeUntil(this.destroy$)).subscribe((seconds) => {
				this.remainingSeconds = seconds;
			});
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	get formattedTime(): string {
		const minutes = Math.floor(this.remainingSeconds / 60);
		const seconds = this.remainingSeconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	}

	onExtendSession(): void {
		this.ref.close('extend');
	}

	onLogout(): void {
		this.ref.close('logout');
	}
}
